export default __webpack_public_path__ + "static/media/video.ed66f17f.png";